// extracted by mini-css-extract-plugin
export default {"root":"dHrlivSKjs","reactionsList":"UyfAxdLbrM"};